import React, { useState } from "react";
import "../styles/home.css";

import { ICONS } from "../../../assets/icons/index";
import { useAspSelector } from "../../../test/jest-redux-hooks";

const Notifications = ({ launchWhatsAppSignup }) => {
  const [notificationIndex, setNotificationIndex] = useState(1);
  const [isVisible, setIsVisible] = useState(true);

  const { currentBrand, currentAccount } = useAspSelector(
    (state) => state?.app
  );

  const brandMode = currentBrand?.brand_mode;

  const notifications = brandMode === 'test' 
  ? ["You are in test mode. Connect your WhatsApp Business Account to go live."]
  : ["Your WhatsApp business account was disconnected"];

  const notify = [
    "You,re currently using Gainwix demo account which ends in 3 days",
    "You,re currently using Gainwix demo account which ends in 1 days",
  ];

  const handleChevronClick = () => {
    setNotificationIndex((prevIndex) => (prevIndex % notifications.length) + 1);
  };

  const handleChevronClick1 = () => {
    setNotificationIndex((prevIndex) => (prevIndex % notify.length) + 1);
  };

  const handleCloseNotifications = () => {
    setIsVisible(false);
  };

  if (!isVisible) return null;
  return (
    <div
      className="homeHeader ptb-5 text-[0.85rem] flex items-center justify-between flex-1 absolute"
      // style={{
      //   background:
      //     "linear-gradient(90deg, #02d1c5 0%, #b49ff9 25%, #fcf7ef 50%, #b49ff9 75%, #02d1c5 100%)",
      // }}
      style={{
        background: `${
          currentBrand?.is_whatsapp_connected
            ? "linear-gradient(90deg, #02d1c5 0%, #b49ff9 25%, #fcf7ef 50%, #b49ff9 75%, #02d1c5 100%)"
            : "linear-gradient(0deg, rgba(255, 84, 62, 0.16), rgba(255, 84, 62, 0.16))"
        }`,
      }}

      // style={{
      //   background: `
      //   linear-gradient(0deg, rgba(10, 205, 149, 0.16), rgba(10, 205, 149, 0.16))
      // `,
      // }}
    >
      {currentBrand?.is_whatsapp_connected ? (
        <marquee>
          <div class="scrolling-text">
            <p>
              Announcement: New update - Sequence feature
              <button class="bg-black text-white py-1 px-2 rounded-xl text-[0.75rem] ml-2">
                View Demo
              </button>
            </p>
            <p class="ml-[10vw]">
              Announcement: New update - Sequence feature
              <button class="bg-black text-white py-1 px-2 rounded-xl text-[0.75rem] ml-2">
                View Demo
              </button>
            </p>
            <p class="ml-[10vw]">
              Announcement: New update - Sequence feature
              <button class="bg-black text-white py-1 px-2 rounded-xl text-[0.75rem] ml-2">
                View Demo
              </button>
            </p>
          </div>
        </marquee>
      ) : (
        <>
          {currentBrand && !currentBrand?.is_whatsapp_connected && (
            // <div className="pt-[1vw] px-[4vw]">
            //   <div
            //     className="w-full h-[3.4vw] flex items-center justify-between px-[0.8vw]"
            //     style={{
            //       background: `url(${images?.WhatsappInactiveBg})`,
            //     }}
            //   >
            //     <div className="text-[var(--white)]">
            //       Your WhatsApp business account was disconnected
            //     </div>
            //     {currentAccount?.role !== "Campaigns Manager" ? (
            //       <button
            //         className="bg-[var(--white)] px-[0.5vw] py-[0.1vw] text-[var(--font-600)] font16px-500 rounded-full flex items-center align-center gap-[0.25vw]"
            //         onClick={() => {
            //           launchWhatsAppSignup();
            //         }}
            //       >
            //         <p>Connect</p>
            //       </button>
            //     ) : (
            // <Tooltip title={"You are not allowed to perform this action"}>
            //   <span className=" cursor-not-allowed">
            //     Connect WhatsApp
            //   </span>
            // </Tooltip>
            //     )}
            //   </div>
            // </div>
            <div className="flex items-center justify-center flex-grow">
              <img
                src={ICONS?.chevronDownCarousel}
                className="rotate-90 pointer"
                onClick={handleChevronClick} // Add click handler to the first chevron
              />

              <p className="text-[#FF543E] font16px-500 pl-3">
                {/* ({notificationIndex}/{notifications.length} Notifications) */}
                {notifications[notificationIndex - 1]}
              </p>
              {currentAccount?.role !== "Campaigns Manager" ? (
                <button
                  className="bg-white py-1 px-2 rounded-xl text-[0.75rem] ml-2 mr-3 "
                  onClick={() => {
                    launchWhatsAppSignup();
                  }}
                >
                  Connect
                </button>
              ) : (
                <Tooltip title={"You are not allowed to perform this action"}>
                  <span className=" cursor-not-allowed">Connect</span>
                </Tooltip>
              )}

              <img
                src={ICONS?.chevronDownCarousel}
                className="-rotate-90 pointer"
                onClick={handleChevronClick}
              />
            </div>
          )}
        </>
      )}

      {/* <div className="flex items-center justify-center flex-grow">
        <img
          src={ICONS?.chevronDownCarousel}
          className="rotate-90 pointer"
          onClick={handleChevronClick1}
        />

        <p className="font-[500] text-[1rem] pl-3">
          ({notificationIndex}/{notify.length} Notifications)
          {notify[notificationIndex - 1]}
        </p>
        <button className="bg-black text-white py-1 px-2 rounded-xl text-[0.75rem] ml-2 mr-3 ">
          Upgrade
        </button>

        <img
          src={ICONS?.chevronDownCarousel}
          className="-rotate-90 pointer"
          onClick={handleChevronClick1}
        />
      </div> */}

      <div className="">
        <img
          className="pointer mr-5 w-[2vw] h-[2vw]"
          src={ICONS.popupX}
          alt="popup"
          onClick={handleCloseNotifications}
        />
      </div>
    </div>
  );
};

export default Notifications;
